// Protected surface: review docs/protected-surfaces/subscription-lifecycle.md before changing Professional-plan route gating behavior.
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useUser } from './contexts/userContext';

/**
 * ProfessionalRoute component that ensures only Professional subscription users can access the route
 */
const ProfessionalRoute = ({ children }) => {
  const { user } = useUser();
  const location = useLocation();

  // Check if user has Professional subscription
  if (!user || user.subscriptionPlan !== 'Professional') {
    const cameFromJourneyGuide = Boolean(
      location.pathname.startsWith('/app')
      && (
        location.state?.fromJourneyGuide
        || location.state?.missionId
        || location.state?.activeMissionId
        || location.state?.missionRoute
      )
    );

    if (cameFromJourneyGuide) {
      return (
        <Navigate
          to="/app/journey-guide"
          replace
          state={{
            navFailure: {
              reason: 'professional_required',
              blockedRoute: location.pathname,
              blockedBy: 'ProfessionalRoute',
              missionSessionId: location.state?.missionId || location.state?.activeMissionId || null
            },
            missionReturnTs: Date.now()
          }}
        />
      );
    }

    // Redirect to pricing page or show upgrade message
    return <Navigate to="/pricing" replace />;
  }

  // User has Professional subscription, allow access
  return children;
};

export default ProfessionalRoute; 
